var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"release_date"},[_c('b-row',[_c('span',{staticClass:"label"},[_vm._v("Date de sortie :")]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.release_date))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }